import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { ApolloClient, HttpLink, InMemoryCache } from '@apollo/client';
import fetch from 'isomorphic-unfetch';
import { setContext } from '@apollo/client/link/context';
var graphqlEndpoints = {
  dev: 'https://gateway.dev.cheggnet.com/personalization-bff-service/graphql',
  test: 'https://gateway.test.cheggnet.com/personalization-bff-service/graphql',
  stage: 'https://gateway.stage.chegg.com/personalization-bff-service/graphql',
  prod: 'https://gateway.chegg.com/personalization-bff-service/graphql'
};
var oneGraphQLEndPoints = {
  dev: 'https://gateway.dev.cheggnet.com/one-graph/graphql',
  test: 'https://gateway.test.cheggnet.com/one-graph/graphql',
  stage: 'https://gateway.stage.chegg.com/one-graph/graphql',
  prod: 'https://gateway.chegg.com/one-graph/graphql'
};
var client;
var oneGraphClient;
var customHeaders = {};
var authLink = setContext(
/* istanbul ignore next */
function (_, _ref) {
  var headers = _ref.headers;
  // return the headers to the context so httpLink can read them
  return {
    headers: _objectSpread(_objectSpread({}, headers), customHeaders)
  };
});
/* istanbul ignore next */

export var setCustomHeader = function setCustomHeader(name, value) {
  customHeaders[name] = value;
};
export var getClient = function getClient(env) {
  client = client ? client : new ApolloClient({
    link: authLink.concat(new HttpLink({
      uri: graphqlEndpoints[env || process.env.CHEGG_ENV],
      credentials: 'include',
      fetchOptions: {
        credentials: 'include'
      },
      fetch: fetch
    })),
    cache: new InMemoryCache()
  });
  return client;
};
/* istanbul ignore next */

export var getOneGraphQLClient = function getOneGraphQLClient(env) {
  // console.log({ testENV: env, cheggENV: process.env.CHEGG_ENV });
  oneGraphClient = oneGraphClient ? oneGraphClient : new ApolloClient({
    link: authLink.concat(new HttpLink({
      uri: oneGraphQLEndPoints[env || process.env.CHEGG_ENV],
      credentials: 'include',
      fetchOptions: {
        credentials: 'include'
      },
      fetch: fetch
    })),
    cache: new InMemoryCache()
  });
  return oneGraphClient;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-plat-ui/utils/dist/esm/client.js
// module id = 708
// module chunks = 11